import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './sbg-dividend-calculator.component.scss';
import axios from 'axios';
var SbgDividendCalculator = /** @class */ (function (_super) {
    tslib_1.__extends(SbgDividendCalculator, _super);
    function SbgDividendCalculator(element) {
        return _super.call(this, element) || this;
    }
    SbgDividendCalculator.prototype.init = function () {
        this.containerDividendPerShare = this.element.querySelector('.js-dividend-per-share');
        this.containerDividendPaymentDate = this.element.querySelector('.js-dividend-payment-date');
        this.containerDividendTotal = this.element.querySelector('.js-dividend-total');
        this.inputPaymentDate = this.element.querySelector('select[name=payment_date]');
        this.inputNumberShares = this.element.querySelector('input[name=number_shares]');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.apiFeed();
    };
    SbgDividendCalculator.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonCalculate) {
            this.buttonCalculate.addEventListener('click', function (event) {
                _this.calculate();
            });
        }
        this.buttonReset.addEventListener('click', function (evt) {
            _this.containerDividendPaymentDate.innerHTML = "-";
            _this.containerDividendPerShare.innerHTML = "-";
            _this.containerDividendTotal.innerHTML = "-";
            setTimeout(function () {
                var dateNew = new Date();
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
                var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
                $('input.js-start-date').datepicker('setDate', dateFormatted);
                $('input.js-start-date').datepicker('setStartDate', dateFormatted);
            }, 500);
        });
    };
    SbgDividendCalculator.prototype.apiFeed = function () {
        var inputPaymentDate = this.inputPaymentDate;
        var url = "https://df.marketdata.feeds.iress.com/feed/2278/?token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzZWNJRCI6NTMyLCJpYXQiOjE2ODUzNDg0OTIsImF1ZCI6ImlyZXNzLmNvLnphIiwiaXNzIjoiYWNjb3VudHMuaXJlc3MuY28uemEifQ.pCMSUAh_tzyEv1W9kpINXshd3X6iWcsar2nuCsUmdIWctKFiHRas9j_1IGcQYMBkwR0O65VM2a-DJvqyrzUk6Q";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            var json = response.data;
            json.Snapshot.map(function (item) {
                var paymentDate = "";
                var formatDate = new Date(item.PayableDate);
                formatDate.setMonth(formatDate.getMonth() + 1);
                var getFullYear = formatDate.getFullYear();
                var getMonth = formatDate.getMonth();
                var getDate = formatDate.getDate();
                if (item.DividendType === 'F') {
                    paymentDate = getFullYear + '/' + getMonth + '/' + getDate;
                }
                else {
                    paymentDate = getFullYear + '/' + getMonth + '/' + getDate;
                }
                var createOption = document.createElement('option');
                createOption.setAttribute('value', item.DividendAmount);
                createOption.setAttribute('data-type', paymentDate);
                createOption.innerHTML = paymentDate;
                inputPaymentDate.appendChild(createOption);
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    SbgDividendCalculator.prototype.calculate = function () {
        var paymentDateText = this.inputPaymentDate.options[this.inputPaymentDate.selectedIndex].text;
        var paymentDateValue = this.inputPaymentDate.value;
        var numberShares = this.inputNumberShares.value;
        var calculation = this.roundFormatter((parseFloat(numberShares) * (parseFloat(paymentDateValue) / 100)), 2, true);
        this.containerDividendPaymentDate.innerHTML = paymentDateText;
        this.containerDividendPerShare.innerHTML = parseFloat(paymentDateValue) / 100 + '0';
        this.containerDividendTotal.innerHTML = calculation;
    };
    SbgDividendCalculator.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    return SbgDividendCalculator;
}(Base));
export { SbgDividendCalculator };



//////////////////
// WEBPACK FOOTER
// ./components/sbg-dividend-calculator/sbg-dividend-calculator.component.ts
// module id = 717
// module chunks = 0